import axios from 'axios'
import {Notification} from 'element-ui'
import {getToken, setToken} from '@/views/brand/utils/auth'

// 创建axios实例
const service = axios.create({
    // baseURL: '/brand', //测试环境
    baseURL: window.OauthConfig.client,
    timeout: 120000 // 请求超时时间
})

// request拦截器
// request拦截器
service.interceptors.request.use(
    config => {
        var token = getToken()
        if (token) {
            config.headers['Authorization'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
        }
        config.headers['Content-Type'] = 'application/json'
        return config
    },
    error => {
        Promise.reject(error)
    }
)

// response 拦截器
service.interceptors.response.use(
    response => {
        return response.data
    },
    error => {
        // 兼容blob下载出错json提示
        if (error.response.data instanceof Blob && error.response.data.type.toLowerCase().indexOf('json') !== -1) {
            const reader = new FileReader()
            reader.readAsText(error.response.data, 'utf-8')
            reader.onload = function (e) {
                let errorMsg = JSON.parse(reader.result).message
                // if (!/[\u4e00-\u9fa5]+/.test(errorMsg)) {
                //   errorMsg = '系统请求有误，请稍后重试！！！'
                // }
                if (errorMsg != null) {
                    Notification.error({
                        title: errorMsg,
                        duration: 5000
                    })
                }

            }
        } else {
            let code = 0
            try {
                code = error.response.status
            } catch (e) {
                if (error.toString().indexOf('Error: timeout') !== -1) {
                    Notification.error({
                        title: 'Network request timeout',
                        duration: 5000
                    })
                    return Promise.reject(error)
                }
            }
            if (code) {
                if (code === 401) {
                    let errorMsg = "Unauthorized"
                    Notification.error({
                        title: errorMsg,
                        duration: 5000
                    })
                } else if (code === 403) {
                    // router.push({ path: '/401' })
                } else {
                    let errorMsg = error.response.data.message
                    if (errorMsg !== undefined) {
                        const re = /[\u4e00-\u9fa5]+/
                        // if (!re.test(errorMsg)) {
                        //   errorMsg = '系统请求有误，请稍后重试！！！'
                        // }
                        Notification.error({
                            title: errorMsg,
                            duration: 5000
                        })
                    }
                }
            } else if (error.response.status === 403) {
                Notification.error({
                    title: 'Sorry, there are no permissions !',
                    duration: 5000
                })
            } else {
                Notification.error({
                    title: 'Interface request failed',
                    duration: 5000
                })
            }
        }
        return Promise.reject(error)
    }
)
export default service
